/**
 * unpoly ships a UMD bundle that assigns `window.up` and exports nothing, so
 * importing it directly yields an empty module. Re-export the global instead.
 *
 * `vite.config.ts` aliases the bare `unpoly` specifier here; the deep path
 * below is not aliased, so this file still reaches the real bundle.
 */
import 'unpoly/unpoly.js';

const up = window.up;

export default up;

export const { compiler } = up;
